module.exports = __webpack_public_path__ + "img/Ens_sec2_03_FM.2a328358.jpg";